import { render } from "./ClaimOR.vue?vue&type=template&id=0137e57a&scoped=true"
import script from "./ClaimOR.vue?vue&type=script&lang=js"
export * from "./ClaimOR.vue?vue&type=script&lang=js"

import "./ClaimOR.vue?vue&type=style&index=0&id=0137e57a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0137e57a"]])

export default __exports__